import { useState, useCallback } from "react";

const useMarkerVisibility = (initialVisibility) => {
  const [visibility, setVisibility] = useState(initialVisibility);

  const toggleVisibility = useCallback((key) => {
    setVisibility((prevVisibility) => {
      const visibilitySet = new Set(prevVisibility);
      if (visibilitySet.has(key)) {
        visibilitySet.delete(key);
      } else {
        visibilitySet.add(key);
      }
      return Array.from(visibilitySet);
    });
  }, []);

  return [visibility, toggleVisibility];
};

export default useMarkerVisibility;
